export default {
  edit_selection: 'Edit selection',
};
